define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
], function(csiAccess, access, full) {
	const PRESENTATION_ADMIN_ROLE = ["Product Presentation Administrator"];

	csiAccess.addViewRoles({
		"_CS_Data": {
			"ProductPresentations": {
				"NewProductPresentation": access(full(PRESENTATION_ADMIN_ROLE)),
			}
		},
	});
});